import { useState, useEffect } from 'react'

const useProjectAccessLevels = (props) => {
    const cacheMinutes = 60
    const localStorageKey = 'users_project_access_levels'
    const localStorageData = localStorage.getItem(localStorageKey) ? JSON.parse(localStorage.getItem(localStorageKey)) : {}
    const [lastUpdated, setLastUpdated] = useState(localStorageData?.lastUpdated || 0)
    const [ projectAccessLevels, setProjectAccessLevels ] = useState([])
    
    useEffect(() => {
        if( lastUpdated + (1000 * 60 * cacheMinutes) > Date.now() ) {
            return
        }
        reload()
    }, [])

    const reload = () => {
        fetch('/v0/users_project_access_levels', { credentials: 'same-origin' })
            .then(function(response) {
                if (!response.ok) throw response
                return response.json()
            })
            .then(function(json) {
                setProjectAccessLevels(json.results)
            })
            .catch(error => {
                console.log("ProjectAccessLevels reload error", error)
            })
    }

    return {
        projectAccessLevels,
    }
}

export default useProjectAccessLevels
